import { createStore } from 'solid-js/store';

import { ITrackProps } from '@/utils/trackEvent';
import { WIDGET_TYPE } from '@/types/constants';

export type EventTracker = {
  track: ({ type, name, data }: ITrackProps) => Promise<void>;
  apiHost: string;
  apiKey: string;
  source: WIDGET_TYPE;
};

// create eventTrackerStore to avoid re-creating the eventTracker object on every render
export const eventTrackerStore = createStore<EventTracker>({
  track: () => Promise.resolve(),
  apiHost: '',
  apiKey: '',
  source: WIDGET_TYPE.HELP, // just a default. This will be overwritten by the widget
});
